"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Header = /*#__PURE__*/function () {
  function Header(page) {
    var _this = this;

    _classCallCheck(this, Header);

    this.DEFAULT_HEADER_HEIGHT = page.platform.isPhone() ? 55 : 85;
    this.HEADER_COLLAPSED_DIFFERENCE = page.platform.isPhone() ? 0 : 30;
    this.container = $("body > header");
    this.innerContainer = $(".inner", this.container);
    this.headerHeight = this.DEFAULT_HEADER_HEIGHT;
    this.window = $(window);
    this.wrapper;
    this.setHeight();
    var sticky = new Waypoint.Sticky({
      element: this.container,
      offset: 0,
      stuckClass: 'stuck'
    });
    this.wrapper = $(sticky.wrapper);
    this.window.scroll(function () {
      _this.setHeight();
    });
  }

  _createClass(Header, [{
    key: "getHeight",
    value: function getHeight() {
      return this.headerHeight;
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      var difference = Math.min(this.window.scrollTop() * 0.2, this.HEADER_COLLAPSED_DIFFERENCE);
      this.headerHeight = Math.min(this.DEFAULT_HEADER_HEIGHT - difference, 85);
      var styles = {
        height: this.headerHeight
      };
      this.container.css(styles);
      this.innerContainer.css(styles);

      if (this.wrapper) {
        $(this.wrapper).css(styles);
      }
    }
  }]);

  return Header;
}();